import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SessionService } from 'src/app/services/session.service';

@Component({
    selector: 'loyale-signout',
    templateUrl: './signout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignoutComponent implements OnInit {

  constructor(private sessionService: SessionService) { }

  ngOnInit() {
    this.sessionService.signOut();
  }

}
